import { NgxSpinnerService } from 'ngx-spinner';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'content-loader',
  templateUrl: './content-loader.component.html',
})
export class ContentLoader {
  @Input() name: string;
  @Input() bdColor: string='rgb(255,255,255,0.1)';
  private _loading = false;
  @Input()
  set loading(value: boolean) {
    this._loading = value;
    if (value) {
      this.spinner.show(this.name);
    } else {
      this.spinner.hide(this.name);
    }
  }
  get loading() {
    return this._loading;
  }
  constructor(private spinner: NgxSpinnerService) { }

  show() {
    this._loading = true;
    this.spinner.show(this.name);
  }

  hide() {
    this._loading = false;
    this.spinner.hide(this.name);
  }
}
